module.exports = __webpack_public_path__ + "img/joe-duke.d557718f.png";